module.exports = __webpack_public_path__ + "static/media/Moe_T.98ba81cb.jpg";